module.exports = __webpack_public_path__ + "static/media/photo-6.b758142b.avif";